import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/Hero';
import FaqPage from './components/FaqPage';
import SettingsPage from './components/SettingsPage';
import AdminPage from './components/AdminPage';
import RewardsPage from './components/RewardsPage';
import LivePage from './components/LivePage';
import { AuthProvider } from './contexts/AuthContext';
import { RefreshProvider } from './context/RefreshContext';
import { MusicPlayerProvider } from './context/MusicPlayerContext';
import RouteMusicSync from './components/RouteMusicSync';

function App() {
  const [userInteracted, setUserInteracted] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleUserInteraction = async () => {
    if (!userInteracted) {
      setUserInteracted(true);
      if (videoRef.current) {
        try {
          await videoRef.current.play();
        } catch (error) {
          console.log('Video autoplay blocked:', error);
        }
      }
    }
  };

  useEffect(() => {
    const playVideo = async () => {
      if (videoRef.current && userInteracted) {
        try {
          await videoRef.current.play();
        } catch (error) {
          console.log('Video autoplay failed:', error);
        }
      }
    };
    playVideo();
  }, [userInteracted]);

  return (
    <AuthProvider>
      <MusicPlayerProvider>
      <BrowserRouter>
      <RouteMusicSync />
        <div className="relative min-h-screen flex flex-col" onClick={handleUserInteraction}>
          {/* Video Background */}
          <video
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            onLoadedData={() => setVideoLoaded(true)}
            className={`fixed inset-0 w-full h-full object-cover z-0 transition-opacity duration-1000 ${
              videoLoaded ? 'opacity-100' : 'opacity-0'
            }`}
            style={{ pointerEvents: 'none' }}
          >
            <source src="/bg.mp4" type="video/mp4" />
          </video>

          {!videoLoaded && (
            <div className="fixed inset-0 w-full h-full bg-gradient-to-br from-gray-900 to-black z-0" />
          )}

          <div className="relative z-10 flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/"         element={<Hero />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/faq"      element={<FaqPage />} />
                <Route path="/rewards"  element={<RewardsPage />} />
                <Route path="/live"     element={<LivePage />} />
                <Route path="/admin"    element={<AdminPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
      </MusicPlayerProvider>
    </AuthProvider>
  );
}

export default function WrappedApp() {
  return (
    <RefreshProvider>
      <App />
    </RefreshProvider>
  );
}